import { Suspense } from 'react';
import {
  useCreateOrUpdatePatient,
  usePatientFormHandler,
} from '@pages/common/Patient/hooks';

import PatientHeader from '@pages/common/Patient/components/PatientHeader';
import Section from '@pages/common/Patient/Forms/components/Section';
import { Stack } from '@mui/material';
import PatientInformationForm from '@pages/common/Patient/components/PatientInformationForm';
import PatientDataForm from '@pages/common/Patient/components/PatientDataForm';
import { PatientFormElement } from './StyledComponents';

import { MainContainer } from '../MainDashboard/StyledComponents';
import { PatientProvider } from './components/PatientProvider';

const Patient = () => {
  const form = usePatientFormHandler();

  const {
    mode,
    patientId,
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = form;

  const onSubmit = useCreateOrUpdatePatient(mode, patientId);

  return (
    <PatientProvider mode={mode} patientId={patientId} form={form}>
      <PatientFormElement id="patient-form" onSubmit={handleSubmit(onSubmit)}>
        {/* <PatientFormElement
        id="patient-form"
        onSubmitCapture={() => console.log('[FORM] onSubmitCapture fired')}
        onSubmit={handleSubmit(onSubmit, (errs) =>
          console.log('[RHF] invalid', errs),
        )}
      > */}
        <PatientHeader control={control} isSubmitting={isSubmitting} />
        <Section
          title="Patient profile"
          description="Maintain the demographic details and clinical information used throughout Synapsys."
        >
          <Stack direction="column" spacing={3}>
            <PatientInformationForm />
            <PatientDataForm />
          </Stack>
        </Section>
      </PatientFormElement>
    </PatientProvider>
  );
};

const PatientWithSuspense = () => (
  <MainContainer sx={{ width: '100%' }}>
    <Suspense fallback={<div>Loading...</div>}>
      <Patient />
    </Suspense>
  </MainContainer>
);

export default PatientWithSuspense;
